<template>
    <div class="example-view">
        <multi-children-vertical-menu :menus="menus" @click="onClickMenuItem"/>
        <div style="width: 100%; height: 100vh; background-color:#F9FCFF; " class="overflow-y-auto">
            <router-view style="width: 80%; margin: 0 auto;" class="pb-10"></router-view>
        </div>
    </div>
</template>

<script>

    import MultiChildrenVerticalMenu from "@/components/common/menu/MultiChildrenVerticalMenu";

    export default {
        name: "ExampleView",
        components: {MultiChildrenVerticalMenu},
        data() {
            return {
                menus: [
                    {
                        text: "Main",
                        id: "main",
                    },
                    {
                        text: "Components",
                        children: [
                            {
                                text: "Data Table",
                                subChildren: [
                                    {
                                        text: "BaseTableLayout",
                                        id: "components.base-table-layout",
                                    },
                                    {
                                        text: "ComponentTable",
                                        id: "components.component-table",
                                    },
                                    {
                                        text: "InfinitePaginationTable",
                                        id: "components.infinite-pagination-table",
                                    },
                                ],
                            },
                            {
                                text: "Mps Data Table",
                                id: "components.form-data-table",
                            },
                            {
                                text: "Vue Data Table",
                                id: "components.vue-data-table",
                            },
                        ],
                    },
                ]
            }
        },
        methods: {
            onClickMenuItem(menu) {
                this.routerManager.push({name: "example." + menu.id});
            },
        },
    }
</script>

<style scoped>
    .example-view {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: start;
    }
</style>